module.exports = __webpack_public_path__ + "img/BS18.19568837.svg";